import { FlexBox, JoonUIColor } from "@joonapp/web-shared"
import { useEffect } from "react"

import CoachInfoModal from "./CoachInfoModal"
import CoachSB from "./CoachSB"
import CoachSBHeader from "./CoachSBHeader"
import CoachSMSConfigModal from "./CoachSMSConfigModal"
import { CoachTab } from "./CoachTabNav"
import FailedPaymentOverlay from "./overlays/FailedPaymentOverlay"
import FTUXOverlay from "./overlays/FTUXOverlay"
import NewRoutinesOverlay from "./overlays/NewRoutinesOverlay"
import PausedSubscriptionOverlay from "./overlays/PausedSubscriptionOverlay"
import SessionBookingOverlay from "./overlays/SessionBookingOverlay"
import TOSOverlay from "./overlays/TOSOverlay"
import useCoachOverlay from "./overlays/useCoachOverlay"
import CoachRoutine from "./routine/CoachRoutine"
import SBStyles from "./SBStyles"
import SessionsTab from "./sessions/SessionsTab"
import PageLoader from "../../components/loading/PageLoader"
import PageContentWrapper from "../../components/pageContentWrapper/PageContentWrapper"
import PageWrapper from "../../components/pageWrapper/PageWrapper"
import useDocumentTitle from "../../hooks/useDocumentTitle"
import { useFamilyQuery } from "../../networking/queries"
import { useCareTeamQuery } from "../../networking/users/queries"
import { FamilyQuerySelect } from "../../types"
import { requireAuth } from "../../util/auth"
import { useRouter } from "../../util/router"
import useCareTeam from "../care/useCareTeam"

const CoachPage = () => {
  useDocumentTitle("Joon - Care")
  const { isLoading } = useCareTeamQuery()
  const { isLoading: isLoadingChildren } = useFamilyQuery(
    FamilyQuerySelect.CHILDREN
  )
  const { careTeam, selectedCoachProfile } = useCareTeam()
  const router = useRouter()
  const coachTab = router.query.coachTab as CoachTab | undefined
  const careTeamUserId = router.query.careTeamUserId as string | undefined

  useCoachOverlay()

  useEffect(() => {
    if (coachTab === undefined) {
      router.push(`/coach/${careTeamUserId}/${CoachTab.MESSAGES}`)
    }
  }, [coachTab, careTeamUserId, router])

  if (isLoading || !selectedCoachProfile) return <></>

  return (
    <PageWrapper style={{ paddingBottom: "0px" }}>
      <PageContentWrapper
        style={{ background: JoonUIColor.background.xlightGray }}
      >
        <CoachSBHeader
          coachProfile={selectedCoachProfile}
          careTeamLength={careTeam?.length || 0}
        />
        {isLoadingChildren && coachTab !== CoachTab.ROUTINE && (
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-white">
            <PageLoader />
          </div>
        )}
        <FlexBox
          direction="column"
          style={{
            width: `min(100%, 600px)`,
            margin: "0 auto",
            borderLeft: `1px solid ${JoonUIColor.border.default}`,
            borderRight: `1px solid ${JoonUIColor.border.default}`,
            height: "calc(100vh - 100px)",
            overflowY: "auto",
            background: JoonUIColor.background.primaryNeutral,
          }}
        >
          {coachTab === CoachTab.MESSAGES && <CoachSB />}
          {coachTab === CoachTab.ROUTINE && <CoachRoutine />}
          {coachTab === CoachTab.SESSIONS && <SessionsTab />}
          <SessionBookingOverlay />
          <FTUXOverlay />
          <FailedPaymentOverlay />
          <NewRoutinesOverlay />
          <PausedSubscriptionOverlay />
        </FlexBox>
        <TOSOverlay />
        <CoachSMSConfigModal />
      </PageContentWrapper>
      <CoachInfoModal />
      <SBStyles />
    </PageWrapper>
  )
}

const CoachPageWithAuth = requireAuth(CoachPage)
export default CoachPageWithAuth
